import PropTypes from 'prop-types'
import React from 'react'
import omit from 'lodash/omit'

class SearchBarInput extends React.Component {
  static propTypes = {
    value: PropTypes.string
  }

  static defaultProps = {
    value: ''
  }

  constructor (props) {
    super(props)
    this.state = {
      value: this.props.value
    }
  }

  componentWillReceiveProps (nextProps) {
    const value = nextProps.value
    if (value !== this.state.value) {
      this.setState({ value })
    }
  }

  onChange (event) {
    this.setState({ value: event.target.value }, () => {
      if (this.props.onChange) {
        this.props.onChange(event)
      }
    })
  }

  render () {
    let passProps = omit(this.props, ['type', 'value', 'onChange', 'aria-label'])

    return (
      <input
        type='search'
        value={this.state.value}
        onChange={this.onChange.bind(this)}
        aria-label='search' {...passProps} />
    )
  }
}

export default SearchBarInput



// WEBPACK FOOTER //
// ./client/components/searchBar/searchBarInput.js